<template>
    <section id="section-cadastrar" class="mx-auto">
        <!-- <div class="col-md-4 col-md-offset-4"> -->
        <div class="panel panel-default m-0">
            <div class="panel-heading">
                <label class="my-1"><i class="fa fa-user-plus"></i> {{appShortName}} Cadastrar</label>
                <a @click="reset" class="text-red mx-2">
                    <span class="px-1">{{ $t("words.cancel") }}</span> <i class="fa fa-times"></i>
                </a>
            </div>
            <div :class="plan" class="text-center py-2 py-lg-4">
                <span>Plano:
                    {{ (typeof status.plano == 'undefined') ? 'Grátis (5 Arquivos)' : status.plano.item.nome }}
                </span>
            </div>
            <!-- /.panel-heading -->
            <div class="panel-body" id="panelListaAssinaturas">
                <!-- <router-link to="/" class="btn float-left btn-default">
                        <i class="fa fa-times"></i> {{ $t('words.cancel') }}
                    </router-link> -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group mb-2 position-relative">
                            <!-- <label>Nome</label> -->
                            <span class="fa fa-user pl-1 form-control-feedback position-absolute"></span>
                            <input type="text" name="nome" :class="{ 'is-invalid': errors.has('nome') }"
                                v-model="request.nome" class="pl-4 form-control"
                                v-bind:placeholder="$t('attributes.name')" v-validate="'required'" />
                            <div class="invalid-feedback help-block error">
                                {{ errors.first("nome") }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group mb-2 position-relative">
                            <!-- <label>CPF</label> -->
                            <span class="fa fa-address-card pl-1 form-control-feedback position-absolute"></span>
                            <input type="text" name="cpf" :class="{ 'is-invalid': errors.has('cpf') }"
                                v-model="request.documento" class="form-control pl-4" v-mask="'###.###.###-##'"
                                placeholder="Insira o CPF" v-validate="'required|document:true'" />
                            <div class="invalid-feedback help-block error">
                                {{ errors.first("cpf") }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group mb-2 position-relative">
                            <!-- <label>Telefone</label> -->
                            <span class="fa fa-phone pl-1 form-control-feedback position-absolute"></span>
                            <input type="text" name="telefone" :class="{ 'is-invalid': errors.has('telefone') }"
                                v-model="request.telefone" class="form-control pl-4"
                                v-mask="['(##)####-####', '(##)#####-####']" placeholder="Insira o número"
                                v-validate="'required'" />
                            <div class="invalid-feedback help-block error">
                                {{ errors.first("telefone") }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group mb-2 position-relative">
                            <!-- <label>E-mail</label> -->
                            <span class="fa fa-envelope pl-1 form-control-feedback position-absolute"></span>
                            <input type="text" name="email" :class="{ 'is-invalid': errors.has('email') }"
                                v-model="request.email" class="form-control pl-4"
                                v-bind:placeholder="$t('attributes.email')" v-validate="'required|email'" />
                            <div class="invalid-feedback help-block error">
                                {{ errors.first("email") }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group mb-2 position-relative">
                            <!-- <label>Senha</label> -->
                            <span class="fa fa-lock pl-1 form-control-feedback position-absolute"></span>
                            <input type="password" ref="password" :class="{ 'is-invalid': errors.has('password') }"
                                name="password" v-model="request.password" class="form-control pl-4"
                                v-bind:placeholder="$t('attributes.password')" v-validate="'required|min:6'" />
                            <div class="invalid-feedback help-block error">
                                {{ errors.first("password") }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group mb-2 position-relative"
                            :class="{ 'is-invalid': errors.has('password_confirmation') }">
                            <!-- <label>Confirmar Senha</label> -->
                            <span class="fa fa-lock pl-1 form-control-feedback position-absolute"></span>
                            <input type="password" name="password_confirmation" v-model="request.password_confirmation"
                                class="form-control pl-4" placeholder="Confirme a senha"
                                v-validate="'required|min:6|confirmed:password'" />
                            <div class="invalid-feedback help-block error">
                                {{ errors.first("password_confirmation") }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row m-0">
                    <div class="col-md-12 d-flex align-items-center text-justify p-3 px-lg-2 py-lg-3">
                        <required class="pr-1" /> <input type="checkbox" id="checkbox" v-validate="{required: true}"
                            name="termos">
                        <label class="pl-2" for="checkbox" :class="{'text-red': errors.has('termos')}">
                            Concordo com os <a @click="handleTermos" href="#">Termos de Serviço</a> do
                            {{appShortName}}.</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button type="button" @click="register()" :disabled="loading"
                            class="btn float-right btn-block btn-primary">
                            <i class="fa fa-check"></i> {{ $t("words.register") }}
                            <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
                        </button>
                    </div>
                </div>
            </div>
            <!-- /.login-box-body -->
        </div>
        <m-choice-termos ref="mChoiceTermos"></m-choice-termos>
    </section>
</template>
<script>
    import mChoiceTermos from './components/m-change-termos.vue'
    export default {
        props: ['status', 'resale'],
        components: {
            mChoiceTermos,
        },
        data() {
            return {
                request: {
                    nome: null,
                    documento: null,
                    email: null,
                    password: null,
                    password_confirmation: null,
                    nascimento: null,
                    grecaptcha: null,
                    fk_plano_id: null,
                },
                loading: false,
                hasError: false,
                plan: "",
            };
        },
        beforeMount() {
            if (typeof this.status.plano == 'undefined') {
                this.plan = "plan-0";
                return;
            }
            switch (this.status.plano.item.nome) {
                default:
                case "Grátis":
                    this.plan = "plan-0";
                    break;
                case "Básico I":
                    this.plan = "plan-1";
                    break;
                case "Básico II":
                    this.plan = "plan-2";
                    break;
                case "Completo":
                    this.plan = "plan-3";
                    break;
            }
        },
        methods: {
            async register() {
                this.loading = true;
                this.request.grecaptcha = await this.$recaptcha("cadastro")
                    .then(token => token);
                this.$validator.validateAll().then((valid) => {
                    if (valid) {
                        this.request.telefone = (this.request.telefone).replace(/[^0-9\\.]+/g, '');
                        if (typeof this.status.plano != 'undefined') {
                            this.request.fk_plano_id = this.status.plano.item.id;
                        }
                        this.request.id_revenda = this.resale.id;
                        this.$store.dispatch("cadastroPublico", this.request)
                            .then((response) => {
                                if (response.status == "success") {
                                    toastr({
                                        icon: response.status,
                                        title: response.message,
                                    });
                                    this.request = {
                                        nome: null,
                                        documento: null,
                                        email: null,
                                        password: null,
                                        password_confirmation: null,
                                        nascimento: null,
                                        grecaptcha: null,
                                        fk_plano_id: null,
                                    }
                                    this.reset();
                                    this.$validator.reset();
                                    this.$route.params.success = {
                                        title: 'Cadastro Efetuado',
                                        message: response.message
                                    }
                                }
                            })
                            .finally(() => this.loading = false)
                    } else {
                        this.loading = false;
                        toastr({
                            icon: 'error',
                            title: 'Verifique os itens em vermelho',
                        });
                    }
                });
            },
            login() {
                this.loading = true;
                this.$auth.login(this.request)
                    .then((response) => {
                        this.loading = false;
                        this.$router.push("/inbox");
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.log(error.response);
                        if (error.response.data.message !== undefined) {
                            toastr({
                                icon: error.response.data.status,
                                title: error.response.data.message,
                            });
                        }
                    });
            },
            reset() {
                this.status.box = "login";
                this.status.plano = {
                    item: {
                        nome: "Grátis (5 Arquivos)",
                    },
                };
            },
            handleTermos() {
                $('#ChangeTermos').modal('toggle');
            }
        },
    };
</script>

<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped>
    body .panel {
        background: #ffffffdd !important;
    }

    #section-cadastrar {
        width: 90%;
    }

    @media screen and (min-width: 992px) {
        #section-cadastrar {
            min-width: 340px;
        }
    }

    #section-cadastrar .panel-heading,
    .form-control {
        background-color: transparent;
    }

    .plan-0 {
        background: linear-gradient(170deg, #0da6dd, #0da6ddaa, #0da6dd);
    }

    .plan-1 {
        background: linear-gradient(170deg, #1e3799, #1e3799aa, #1e3799);
    }

    .plan-2 {
        background: linear-gradient(170deg, #001464, #001464aa, #001464);
    }

    .plan-3 {
        background: linear-gradient(170deg, #0e1638, #0e1638aa, #0e1638);
    }

    .panel-heading a {
        cursor: pointer;
    }

    .panel [class*="plan"] {
        font-size: 18px;
        font-weight: 600;
        color: white;
    }

    .form-control {
        border: 0;
        border-bottom: 1px solid dimgray;
    }

    input.form-control::placeholder {
        color: dimgray;
    }

    input.form-control:focus {
        outline-width: 0;
    }

    .form-control-feedback {
        left: 0;
        color: #777;
    }

    .has-feedback .form-control {
        padding-right: 12px;
        padding-left: 30px;
    }

    .has-error .form-control-feedback {
        color: #a94442 !important;
    }
</style>